// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs__1T29G","tab":"tab__3Xnnp","tabWrapper":"tabWrapper__1_GPX","separator":"separator__3Sa2l","tabActive":"tabActive__1-24N"};